import React from 'react';
import { get, post, put, del, patch } from '../../../../../Utility/Http';
import { adminGroupsGet, adminGroupPost, adminGroupPatch, adminGroupDeleteApi, contact_group_contact_create_post, contact_group_contact_remove_api, getMembersListData, ContactsListingGet, getUserListData, adminGroupMappingGet, organisationGet, userPost, userPatch, userRelationDetailsGet, userDeleteApi, checkUserLimitGet, getOrgBranchListGet,role_list_get } from '../Model/GroupModel';
import Config from '../../../../../Utility/Config';



export const adminGroupsListing = (data) => {
    return get(`${Config.extendedUrl}admin_groups`, data).then((response) => {
        return adminGroupsGet(response)
    });
};

export const getMembersList = (data) => {
    return get(`${Config.extendedUrl}admin_group_mapping`, data).then((response) => {
        return getMembersListData(response)
    });
};


export const getAllUserList = (data) => {
    return get(`${Config.extendedUrl}admin/users/list`, data).then((response) => {
        return getUserListData(response)
    });
};
export const adminGroup = (data, id, type) => {
    if (type == 'post') {
        return post(`${Config.extendedUrl}admin_groups`, data).then((response) => {
            return adminGroupPost(response)
        });
    } else {
        return patch(`${Config.extendedUrl}admin_groups/${id}`, data).then((response) => {
            return adminGroupPatch(response)
        });
    }
};

export const adminGroupDelete = (data) => {
    return del(`${Config.extendedUrl}admin_groups`, data).then((response) => {
        return adminGroupDeleteApi(response)
    });
};

export const contact_group_contact_create = (data) => {
    return post(`${Config.extendedUrl}admin_group_mapping`, data).then((response) => {
        return contact_group_contact_create_post(response)
    });
};

export const contact_group_contact_remove = (data) => {
    return del(`${Config.extendedUrl}admin_group_mapping`, data).then((response) => {
        return contact_group_contact_remove_api(response)
    });
};

export const ContactsList = (data, type) => {
    if (type == 'add_contacts') {
        return get(`${Config.extendedUrl}admin_group_mapping/excluded_user`, data).then((response) => {
            return ContactsListingGet(response)
        });
    } else {
        return get(`${Config.extendedUrl}admin_group_mapping`, data).then((response) => {
            return adminGroupMappingGet(response)
        });
    }
};

export const organisation = (data) => {
    return get(`${Config.extendedUrl}organisation`, data).then((response) => {
        return organisationGet(response)
    });

};

export const userAddEdit = (data, id, type) => {
    if (type == 'post') {
        return post(`${Config.extendedUrl}admin/users`, data).then((response) => {
            return userPost(response)
        });
    } else {
        return patch(`${Config.extendedUrl}admin/users/${id}`, data).then((response) => {
            return userPatch(response)
        });
    }
};

export const userRelationalDetailsAdd = (data, type, id = "") => {
    if (type == "post") {
        return post(`${Config.extendedUrl}org_user_relations`, data).then((response) => {
            return userRelationDetailsGet(response)
        });
    } else if (type == "patch") {
        return patch(`${Config.extendedUrl}org_user_relations/${id}`, data).then((response) => {
            return userRelationDetailsGet(response)
        });
    }
};

export const userDelete = (data) => {
    return del(`${Config.extendedUrl}admin/users`, data).then((response) => {
        return userDeleteApi(response)
    });
};


export const checkUserLimit = (data) => {
    return get(`${Config.extendedUrl}admin/check_user_limit`, data).then((response) => {
        return checkUserLimitGet(response)
    });
};

export const getOrgBranch = (data, userType = "admin", hotelId) => {
    return get(`${Config.extendedUrl}org_branch`, data).then((response) => {
        return getOrgBranchListGet(response)
    });
};

export const roleList = (data) => {
    return get(`${Config.extendedUrl}roles`, data).then((response) => {
        return role_list_get(response)
    });
};
